import React, { useContext } from "react";
import { useState, useEffect, useRef } from "react";
import "../../../../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import ModalSave from "../../../../../common/ModelSave";
import Validation from "../../../../../common/FormValidation";
import { CancelButton, SaveButton } from "../../../../../common/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { useForm, Controller } from 'react-hook-form';
import classNames from "classnames";
library.add(fas);

const EditOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);

  const id = props.show;
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/masters/ed-tech/course/ug-courses/bba/what_is/${id}`);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset,
    watch,
    setValue,
    control,
    trigger,
  } = useForm();

  const imageFile = watch("image");
  const videoFile = watch("video");
  const descriptionValue = watch("description");

  const onSubmit = async (data) => {
    try {
      const fromData = new FormData();
      fromData.append("name", data?.name);
      fromData.append("description", data?.description);
      if (typeof data?.video !== "string") {
        fromData.append("video", data?.video[0]);
      }
      const response = await postData(
        `/masters/ed-tech/course/ug-courses/bba/what_is/${id}`,
        fromData
      );
      console.log(response);
      if (response?.success) {
        await setShowModal({ code: response?.code, message: response?.message });
      } else {
        await setShowModal({ code: response?.code, message: response?.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        onHide={props.handleClose}
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Reasons
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            role="form"
            className="countryclass"
          >
            <Row>
              {/* Left side: Title and Image Upload */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Title</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          type="text"
                          {...register("name", {
                            required: "Title is required",
                            maxLength: { value: 30, message: "Title cannot exceed 30 characters" },
                          })}
                          placeholder="Title"
                        />
                      </Form.Group>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Video</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.video,
                          })}
                          type="file"
                          {...register("video")}
                          accept="video/mp4, video/x-m4v, video/*"
                        />
                      </Form.Group>
                      {errors.video && (
                        <span className="text-danger">
                          {errors.video.message}
                        </span>
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Right side: Image Preview */}
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Video Preview</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={9}>
                      {typeof getValues("video") == "string" ? (
                        <div className="image-preview-container">
                          <video
                            src={IMG_URL + getValues("video")}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "150px", height: "130px" }}
                            muted
                            controls
                          />
                        </div>
                      ) : (
                        videoFile &&
                        videoFile?.length > 0 && (
                          <div className="image-preview-container">
                            <video
                              // src={URL.createObjectURL(getValues("image")[0])}
                              src={URL?.createObjectURL(videoFile[0])}
                              alt="Preview"
                              className="image-preview"
                              style={{ width: "150px", height: "130px" }}
                              controls
                              muted
                            />
                          </div>
                        )
                      )}
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Bottom: Description */}
              <Col lg={12}>
                <div className="main-form-section mt-3">
                  <Form.Label className="text-center">Description</Form.Label>
                  <Row className="justify-content-center">
                    <Col sm={12}>
                      <Form.Group>
                        <Controller
                          name="description"
                          control={control}
                          rules={{ required: 'Description is required.', maxLength: { value: 609, message: 'Description must be at most 600 characters long.' } }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger('description');
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                        {errors.description && (
                          <span className="text-danger">
                            {errors.description.message}
                          </span>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/* Buttons */}
            <Row className="justify-content-center mt-5 pb-3">
              <Col sm={6} className="d-flex justify-content-center">
                <CancelButton name={"Cancel"} handleClose={props.handleClose} />
                <SaveButton
                  name={"Save"}
                  handleSubmit={handleSubmit(onSubmit)}
                />
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
